import React, { useState, useCallback, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { getEditorHistory } from "../../api/user";
import { downloadCSV } from "../../../helpers/dataTableHelper";
import moment from "moment";

function EditorHistory() {
  const { id } = useParams();

  const [Pdata, PsetData] = useState([]);
  const [Ploading, PsetLoading] = useState(false);
  const [PtotalRows, PsetTotalRows] = useState(0);
  const [PperPage, PsetPerPage] = useState(10);
  const [PcurrentPage, PsetCurrentPage] = useState(1);
  const [PreqParams, PsetReqParams] = useState({
    page: PcurrentPage,
    limit: PperPage,
    sort_by: "date",
    sort_direction: "desc",
    recruiter_id: id,
    res_type: "favorites",
  });
  const [Pfetch, PsetFetch] = useState(true);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState({
    favorites_count: 0,
    unlocked_count: 0,
    job_posted: 0,
    resume_download: 0,
    created_by_name: "",
  });
  const [dateFilter, setDateFilter] = useState({
    from_date: "",
    to_date: "",
  });
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "date",
    sort_direction: "desc",
    recruiter_id: id,
    res_type: "unlocked",
  });
  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      if (params?.res_type === "unlocked") {
        setLoading(true);
      } else if (params?.res_type === "favorites") {
        PsetLoading(true);
      }

      getEditorHistory(params)
        .then((res) => {
          if (params?.res_type === "unlocked") {
            setData(res?.data?.unlocked);
            setTotalRows(res?.data?.totalRecords);
            setLoading(false);
            setFetch(false);
            if (res.data.unlocked_count !== undefined) {
              setCount((pre) => ({
                ...pre,
                unlocked_count: res?.data?.unlocked_count,
                job_posted: res?.data?.jobs_count,
                resume_download: res?.data?.downloads_count,
                created_by_name: res?.data?.created_by_name || "",
              }));
            }
          } else if (params?.res_type === "favorites") {
            PsetData(res?.data?.favorites);
            PsetTotalRows(res?.data?.totalRecords);
            PsetLoading(false);
            PsetFetch(false);
            if (res.data.favorites_count !== undefined) {
              setCount((pre) => ({
                ...pre,
                favorites_count: res?.data?.favorites_count,
                job_posted: res?.data?.jobs_count,
                resume_download: res?.data?.downloads_count,
                created_by_name: res?.data?.created_by_name || "",
              }));
            }
          }
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          if (params?.type === "u") {
            setLoading(false);
            setFetch(false);
          } else if (params?.type === "f") {
            PsetLoading(false);
            PsetFetch(false);
          }
        });
    },
    [setFetch, PsetFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers({ ...reqParams, ...dateFilter });
    }
  }, [fetch, reqParams, dateFilter]);

  useEffect(() => {
    if (Pfetch) {
      fetchUsers({ ...PreqParams, ...dateFilter });
    }
  }, [Pfetch, PreqParams, dateFilter]);

  const columns = useMemo(
    () => [
      {
        name: "Candidate ID",
        selector: (row) => row.candidate_id,
        sortable: true,
        sortField: "candidate_id",
      },
      {
        name: "Name",
        selector: (row) => row.legal_name,
        sortable: true,
        sortField: "legal_name",
      },
      {
        name: "Preferred Name",
        selector: (row) => row.preferred_name,
        sortable: true,
        sortField: "preferred_name",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
        wrap: true,
        sortField: "email",
      },
      {
        name: "Created by",
        selector: (row) => row.created_by,
        //sortable: true,
        sortField: "created_by",
      },
      {
        name: "Date",
        selector: (row) => row.date,
        sortable: true,
        sortField: "date",
      },
    ],
    []
  );

  const handlePageChange = useCallback(
    (page, type = "u") => {
      if (type === "u") {
        setCurrentPage(page);
        setReqParams({
          ...reqParams,
          page: page,
        });
        setFetch(true);
      } else if (type === "f") {
        PsetCurrentPage(page);
        PsetReqParams({
          ...PreqParams,
          page: page,
        });
        PsetFetch(true);
      }
    },
    [setReqParams, reqParams, setFetch, PsetReqParams, PreqParams, PsetFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page, type = "u") => {
      if (type === "u") {
        setPerPage(newPerPage);
        setReqParams({
          ...reqParams,
          limit: newPerPage,
        });
        setFetch(true);
      } else if (type === "f") {
        PsetPerPage(newPerPage);
        PsetReqParams({
          ...PreqParams,
          limit: newPerPage,
        });
        PsetFetch(true);
      }
    },
    [setReqParams, reqParams, setFetch, PsetReqParams, PreqParams, PsetFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection, data, type = "u") => {
      if (column?.sortField !== undefined) {
        if (type === "u") {
          setReqParams({
            ...reqParams,
            sort_by: column.sortField,
            sort_direction: sortDirection,
          });
          setFetch(true);
        } else if (type === "f") {
          PsetReqParams({
            ...PreqParams,
            sort_by: column.sortField,
            sort_direction: sortDirection,
          });
          PsetFetch(true);
        }
      }
    },
    [reqParams, setReqParams, setFetch, PreqParams, PsetReqParams, PsetFetch]
  );

  return (
    <>
      <div className="row mb-3">
        <div className="col-md-3">
          <div className="form-group">
            <label className="text-black font-w500">From date</label>
            <input
              type="date"
              className="form-control"
              autoComplete="off"
              max={moment(new Date()).format("YYYY-MM-DD")}
              name="from_date"
              value={dateFilter.from_date}
              onChange={(e) => {
                setDateFilter({
                  ...dateFilter,
                  from_date: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <label className="text-black font-w500">To date</label>
            <input
              type="date"
              className="form-control"
              autoComplete="off"
              name="to_date"
              max={moment(new Date()).format("YYYY-MM-DD")}
              value={dateFilter.to_date}
              onChange={(e) => {
                setDateFilter({
                  ...dateFilter,
                  to_date: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label className="text-black font-w500"></label>
          <div className="form-group mt-2">
            <button
              className="btn btn-warning btn-sm"
              onClick={() => {
                setFetch(true);
                PsetFetch(true);
              }}
            >
              <i className="fa fa-search"></i>
            </button>
            <button
              className="btn btn-danger btn-sm ms-2"
              onClick={() => {
                setDateFilter({
                  from_date: "",
                  to_date: "",
                });
                setFetch(true);
                PsetFetch(true);
              }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-7">
          <button className="btn btn-success btn-sm">
            <b>{count?.unlocked_count}</b> Unlocked
          </button>
          <button className="btn btn-info btn-sm ms-2">
            <b>{count?.favorites_count}</b> Favourites
          </button>
          <Link
            to={"/job_list?created_by_name=" + count?.created_by_name}
            className="btn btn-warning btn-sm ms-2"
          >
            <b>{count?.job_posted}</b> Jobs posted
          </Link>
          <button className="btn btn-primary btn-sm ms-2">
            <b>{count?.resume_download}</b> Resume download
          </button>
        </div>
        <div className="col-md-5 text-end mb-2">
          <button
            onClick={() => downloadCSV(data, "unlock-candidate-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
          <Link to={`/user_list`} className="btn btn-sm btn-primary ">
            <i className="fa fa-arrow-left"></i> Back
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>Unlock Profile</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                  persistTableHead
                  onSort={handleSort}
                  sortServer
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"500px"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-md-12 text-end">
          <button
            onClick={() => downloadCSV(Pdata, "favourite-candidate-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4>Favorite Profile</h4>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Pdata}
                  progressPending={Ploading}
                  pagination
                  paginationServer
                  paginationTotalRows={PtotalRows}
                  paginationDefaultPage={PcurrentPage}
                  onChangeRowsPerPage={(a, b) => handlePerRowsChange(a, b, "f")}
                  onChangePage={(a) => handlePageChange(a, "f")}
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
                  persistTableHead
                  onSort={(a, b, c) => handleSort(a, b, c, "f")}
                  sortServer
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"500px"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditorHistory;
